import { IStyles } from '../../interfaces/styles';

export const classes: IStyles = {
  root: {
    cursor: 'pointer',
    ml: '0 !important',
  },
};
